import { render, staticRenderFns } from "./linksConfig.component.html?vue&type=template&id=0c02150c&scoped=true&"
import script from "./LinksConfig.vue?vue&type=script&lang=ts&"
export * from "./LinksConfig.vue?vue&type=script&lang=ts&"
import style0 from "./linksConfig.component.scss?vue&type=style&index=0&id=0c02150c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c02150c",
  null
  
)

export default component.exports